<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
        <div class='h-inputLit'>
          <span>{{$t('MCS.groupNum')}}</span>
        </div>
        <input class="e-input" :value='groupid' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox">
      <div class="h-dialog-borderBox-topIcon">
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
              <div>
                <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='delArea'>
                  <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='300px' :allowResizing='true'>
          <e-columns>
            <e-column headerText='groupAreaConfigId' :visible='false' width='25' textAlign='Center'></e-column>
            <e-column field='cellId' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.cellId")' width='200' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden; margin-left:-20px; height: 65px">
        <div class="h-col-inputBox">
          <span>{{$t('MCS.cellNumber')}}</span>
          <div style="margin-left: -20px">
            <div class="col-sm-11">
              <ejs-textbox v-model='cellId'></ejs-textbox>
            </div>
            <div class="col-sm-1">
              <div class="h-toolbarBg h-subscriber-listRemoveButton" style="margin-top: -5px">
                <ejs-toolbar>
                  <div>
                    <div>
                      <button class="e-tbar-btn e-control e-btn e-lib e-icon-btn"  data-ripple="true" @click="addArea" tabindex="-1" style="width: auto;" :title='$t("MCS.add")'>
                        <span class='icon hero-icon hero-icon-add-small'></span>
                      </button>
                    </div>
                  </div>
                </ejs-toolbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonJS from '../../common';

export default {
  name: 'GroupArea',
  mixins: [commonJS],
  props: [
    'neid',
  ],
  data() {
    return {
      groupid: '',
      data: {},
      cellId: '',
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0
      }
    };
  },
  methods: {
    getGridData(groupid = this.groupid) {
      const $this = this;
      $this.groupid = groupid;
      const params = {
        vo: {
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          groupId: groupid,
          flag: 0
        },
        info: {
          neid: $this.neid,
          msgid: this.msg.qryGroupArea
        },
        page: {
          pageNo: $this.page.pageNo,
          pageSize: $this.page.pageSize
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.totalCnt;
      });
    },
    addArea() {
      const $this = this;
      const params = {
        vo: {
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          groupId: $this.groupid,
          cellId: $this.cellId
        },
        info: {
          neid: $this.neid,
          msgid: $this.msg.addGroupArea
        }
      };
      $this.cellId = '';
      $this.$axios.post($this.requestCommon, params).then((response) => {
        $this.commonResp(response);
        $this.getGridData();
      });
    },
    delArea() {
      const $this = this;
      const record = $this.$refs.grid.getSelectedRecords();
      if (record.length === 0) {
        $this.$toast('warning', $this.$t('Common.tips.noSelect'));
        return;
      };
      const params = {
        vo: {
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          flag: 0,
          groupId: $this.groupid,
          groupAreaConfigId: record[0].groupAreaConfigId
        },
        info: {
          neid: $this.neid,
          msgid: $this.msg.delGroupArea
        }
      };
      $this.$axios.post($this.requestCommon, params).then((response) => {
        $this.commonResp(response);
        $this.getGridData();
      });
    },
  },
};
</script>

<style scoped>

</style>
